import { inject, Injectable } from '@angular/core'
import { HttpClient } from '@angular/common/http'
import { map, Observable } from 'rxjs'
import { environment } from '@environments/environment'
import { TemplateApiResponse } from '../models/template.model'

@Injectable({
  providedIn: 'root'
})
export class TemplateService {
  private readonly http = inject(HttpClient)
  private readonly apiUrl = environment.templateApiUrl

  public getById(uuid: string): Observable<TemplateApiResponse> {
    return this.http.get<TemplateApiResponse>(`${this.apiUrl}/${uuid}`)
  }

  public listAll(): Observable<TemplateApiResponse[]> {
    return this.http.get<TemplateApiResponse[]>(`${this.apiUrl}/list`)
  }

  public create(data: TemplateApiResponse): Observable<TemplateApiResponse> {
    return this.http.post<TemplateApiResponse>(`${this.apiUrl}`, data)
  }

  public update(data: TemplateApiResponse): Observable<TemplateApiResponse> {
    return this.http.put<TemplateApiResponse>(`${this.apiUrl}/${data.uuid}`, data)
  }

  public checkTemplateExists(title: string): Observable<boolean> {
    return this.http.get<{ exist: boolean }>(`${this.apiUrl}/exist`, {
      params: { title }
    }).pipe(
      map(response => response.exist)
    )
  }

  public delete(uuid: string): Observable<boolean> {
    return this.http.delete<{ status: string, message: string }>(`${this.apiUrl}/${uuid}`)
      .pipe(
        map(response => response.status === 'OK')
      )
  }

  public checkConditionExists(certificateCategory: string, coverageType: string): Observable<boolean> {
    return this.http.get<{ exist: boolean }>(`${this.apiUrl}/conditionExist`, {
      params: { certificateCategory, coverageType }
    }).pipe(
      map(response => response.exist)
    )
  }

  public getTags(q: string): Observable<string[]> {
    return this.http.get<string[]>(`${this.apiUrl}/tags`, {
      params: { q }
    })
  }

  public save(data: TemplateApiResponse): Observable<TemplateApiResponse> {
    const uuidValue = data.uuid

    const hasUuid = uuidValue !== null &&
      uuidValue !== undefined
    return hasUuid
      ? this.update(data)
      : this.create(data)
  }
}
